/**
 * Format a system size for display.
 * Round to 2 decimal places and add ' MW' to the end.
 * @param systemSize - A number representing the system size in MW.
 * @returns A string of the system size in this format: 0.12 MW
 */
export function formatSystemSize(systemSize: number) {
  return `${Math.round(systemSize * 100) / 100} MW`
}
